import { useEffect, useState } from "react";
import { getServices } from "../../api/api";
// import ThemeIcon from "../ThemeIcon/ThemeIcon"; // Ensure you have a ThemeIcon component or replace with your icon library
import ThemeIcon from "../../components/ThemeIcon/ThemeIcon";
import "./ServiceBanner.scss";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import { Link } from "react-router-dom";

const ServiceGrid = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const data = await getServices();
      setServices(data);
    }
    fetchData();
  }, []);

 return (
   <section
     className="service-grid-section section-common pb-70"
     data-aos="fade-up"
     data-aos-duration="2000"
   >
     <div className="container">
       {/* Main Title */}
       <SectionTitle
         subTitle="Our Services"
         title="Expert Dental Services for a Healthier Smile"
         description="Our dental care services cover a wide range of symptoms including persistent tooth pain, sensitivity to hot or cold, swollen gums, deep decay, and cracked teeth. Early treatment can save your tooth and prevent further complications."
       />
       {/* <div className="section-header text-center">
         <h2 className="mb-2">Our Services</h2>
         <p className=" mb-4">
           Discover the range of services we offer to support your success.
         </p>
       </div> */}

       {/* Services Grid */}
       <div className="grid-wrapper">
         {services.map((service, idx) => (
           <div className="service-card" key={service.id || idx}>
             {/* <div className="icon-container">
               <ThemeIcon icon={service.icon} />
             </div> */}
             <h3>{service.name}</h3>
             <p>{service.description}</p>
           </div>
         ))}
       </div>

       {/* AI Dental Checkup Feature */}
       <div className="ai-checkup-section text-center mt-5" data-aos="fade-up" data-aos-duration="2000">
         <div className="ai-checkup-card">
           <div className="ai-icon">
             <i className="fas fa-robot"></i>
           </div>
           <h3>AI-Powered Dental Checkup</h3>
           <p>Get instant dental analysis using our advanced AI technology. Upload a photo or use your camera for a quick assessment.</p>
           <Link to="/dental-checkup" className="ai-checkup-btn">
             Try AI Checkup Now
           </Link>
         </div>
       </div>
     </div>
   </section>
 );

};

export default ServiceGrid;
